import { TimeFrameKey } from 'data/time-frames';
import { createContext, useContext } from 'react';

export type AiInsightsContextValue = {
  isOpen: boolean;
  question?: string;
  openAiInsights: (
    question: string,
    pageName: 'Portfolio' | 'Assets' | 'Explore',
    productCode?: string,
    productType?: string,
  ) => void;
  closeAiInsights: () => void;
};

export const AiInsightsContext = createContext<AiInsightsContextValue | null>(
  null,
);

export function useAiInsights() {
  const context = useContext(AiInsightsContext);

  if (!context) {
    throw new Error(
      'useAiInsights must be used within a AiInsightsContext provider',
    );
  }

  return context;
}
